var _IMapMappedClass_map, _IMapMappedClass_toKey, _IMapMappedClass_fromKey;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { pipe } from '../functional';
import { objectIs, tp } from '../others';
import { IList } from './list';
export const IMapMapped = {
    new: (iterable, toKey, fromKey) => new IMapMappedClass(iterable, toKey, fromKey),
    equal: (a, b) => {
        if (a.size !== b.size)
            return false;
        return a.every((v, k) => b.get(k) === v);
    },
};
class IMapMappedClass {
    constructor(iterable, toKey, fromKey) {
        _IMapMappedClass_map.set(this, void 0);
        _IMapMappedClass_toKey.set(this, void 0);
        _IMapMappedClass_fromKey.set(this, void 0);
        // eslint-disable-next-line no-restricted-globals
        __classPrivateFieldSet(this, _IMapMappedClass_map, new Map(IList.fromMapped(iterable, ([k, v]) => [toKey(k), v])), "f");
        __classPrivateFieldSet(this, _IMapMappedClass_toKey, toKey, "f");
        __classPrivateFieldSet(this, _IMapMappedClass_fromKey, fromKey, "f");
    }
    get size() {
        return __classPrivateFieldGet(this, _IMapMappedClass_map, "f").size;
    }
    has(key) {
        return __classPrivateFieldGet(this, _IMapMappedClass_map, "f").has(__classPrivateFieldGet(this, _IMapMappedClass_toKey, "f").call(this, key));
    }
    get(key) {
        return __classPrivateFieldGet(this, _IMapMappedClass_map, "f").get(__classPrivateFieldGet(this, _IMapMappedClass_toKey, "f").call(this, key));
    }
    every(predicate) {
        for (const [k, v] of this.entries()) {
            if (!predicate(v, k))
                return false;
        }
        return true;
    }
    some(predicate) {
        for (const [k, v] of this.entries()) {
            if (predicate(v, k))
                return true;
        }
        return false;
    }
    delete(key) {
        if (!this.has(key))
            return this;
        const keyMapped = __classPrivateFieldGet(this, _IMapMappedClass_toKey, "f").call(this, key);
        return IMapMapped.new(IList.from(__classPrivateFieldGet(this, _IMapMappedClass_map, "f"))
            .filter(([km]) => !objectIs(km, keyMapped))
            .map(([km, v]) => tp(__classPrivateFieldGet(this, _IMapMappedClass_fromKey, "f").call(this, km), v)), __classPrivateFieldGet(this, _IMapMappedClass_toKey, "f"), __classPrivateFieldGet(this, _IMapMappedClass_fromKey, "f"));
    }
    set(key, value) {
        if (value === this.get(key))
            return this; // has no changes
        const keyMapped = __classPrivateFieldGet(this, _IMapMappedClass_toKey, "f").call(this, key);
        if (!this.has(key)) {
            return IMapMapped.new([...__classPrivateFieldGet(this, _IMapMappedClass_map, "f"), tp(keyMapped, value)].map(([km, v]) => tp(__classPrivateFieldGet(this, _IMapMappedClass_fromKey, "f").call(this, km), v)), __classPrivateFieldGet(this, _IMapMappedClass_toKey, "f"), __classPrivateFieldGet(this, _IMapMappedClass_fromKey, "f"));
        }
        else {
            return IMapMapped.new(IList.fromMapped(__classPrivateFieldGet(this, _IMapMappedClass_map, "f"), ([km, v]) => tp(__classPrivateFieldGet(this, _IMapMappedClass_fromKey, "f").call(this, km), objectIs(km, keyMapped) ? value : v)), __classPrivateFieldGet(this, _IMapMappedClass_toKey, "f"), __classPrivateFieldGet(this, _IMapMappedClass_fromKey, "f"));
        }
    }
    update(key, updater) {
        if (!this.has(key))
            return this;
        const curr = this.get(key);
        const keyMapped = __classPrivateFieldGet(this, _IMapMappedClass_toKey, "f").call(this, key);
        return IMapMapped.new(IList.fromMapped(__classPrivateFieldGet(this, _IMapMappedClass_map, "f").entries(), (keyValue) => pipe(keyValue)
            .chain(([km, v]) => tp(km, objectIs(km, keyMapped) ? updater(curr) : v))
            .chain(([km, v]) => tp(__classPrivateFieldGet(this, _IMapMappedClass_fromKey, "f").call(this, km), v)).value), __classPrivateFieldGet(this, _IMapMappedClass_toKey, "f"), __classPrivateFieldGet(this, _IMapMappedClass_fromKey, "f"));
        // return IMapMapped.new(
        //   Array.from(this._map.entries(), ([km, v]) => tp(this._fromKey(km), v))(
        //     ([km, v]) => tp(km, objectIs(km, keyMapped) ? updater(curr) : v)
        //   ),
        //   this._toKey,
        //   this._fromKey
        // );
    }
    withMutations(actions) {
        // eslint-disable-next-line no-restricted-globals
        const result = new Map(__classPrivateFieldGet(this, _IMapMappedClass_map, "f"));
        for (const action of actions) {
            const key = __classPrivateFieldGet(this, _IMapMappedClass_toKey, "f").call(this, action.key);
            switch (action.type) {
                case 'delete':
                    result.delete(key);
                    break;
                case 'set':
                    result.set(key, action.value);
                    break;
                case 'update': {
                    if (result.has(key)) {
                        result.set(key, action.updater(result.get(key)));
                    }
                    break;
                }
            }
        }
        return IMapMapped.new(IList.fromMapped(result, ([k, v]) => [__classPrivateFieldGet(this, _IMapMappedClass_fromKey, "f").call(this, k), v]), __classPrivateFieldGet(this, _IMapMappedClass_toKey, "f"), __classPrivateFieldGet(this, _IMapMappedClass_fromKey, "f"));
    }
    map(mapFn) {
        return IMapMapped.new(this.toArray().map(([k, v]) => tp(k, mapFn(v, k))), __classPrivateFieldGet(this, _IMapMappedClass_toKey, "f"), __classPrivateFieldGet(this, _IMapMappedClass_fromKey, "f"));
    }
    mapKeys(mapFn) {
        return IMapMapped.new(this.toArray().map(([k, v]) => tp(mapFn(k), v)), __classPrivateFieldGet(this, _IMapMappedClass_toKey, "f"), __classPrivateFieldGet(this, _IMapMappedClass_fromKey, "f"));
    }
    mapEntries(mapFn) {
        return IMapMapped.new(this.toArray().map(mapFn), __classPrivateFieldGet(this, _IMapMappedClass_toKey, "f"), __classPrivateFieldGet(this, _IMapMappedClass_fromKey, "f"));
    }
    forEach(callbackfn) {
        for (const [km, value] of __classPrivateFieldGet(this, _IMapMappedClass_map, "f").entries()) {
            callbackfn(value, __classPrivateFieldGet(this, _IMapMappedClass_fromKey, "f").call(this, km));
        }
    }
    *[(_IMapMappedClass_map = new WeakMap(), _IMapMappedClass_toKey = new WeakMap(), _IMapMappedClass_fromKey = new WeakMap(), Symbol.iterator)]() {
        for (const e of this.entries()) {
            yield e;
        }
    }
    *keys() {
        for (const km of __classPrivateFieldGet(this, _IMapMappedClass_map, "f").keys()) {
            yield __classPrivateFieldGet(this, _IMapMappedClass_fromKey, "f").call(this, km);
        }
    }
    *values() {
        for (const v of __classPrivateFieldGet(this, _IMapMappedClass_map, "f").values()) {
            yield v;
        }
    }
    *entries() {
        for (const [km, v] of __classPrivateFieldGet(this, _IMapMappedClass_map, "f").entries()) {
            yield [__classPrivateFieldGet(this, _IMapMappedClass_fromKey, "f").call(this, km), v];
        }
    }
    toKeysArray() {
        return IList.from(this.keys());
    }
    toValuesArray() {
        return IList.from(this.values());
    }
    toEntriesArray() {
        return IList.from(this.entries());
    }
    toArray() {
        return IList.from(this.entries());
    }
    toRawMap() {
        return __classPrivateFieldGet(this, _IMapMappedClass_map, "f");
    }
}
